import { useEffect, useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import {
  AnalyticsEvent,
  analyticsIdentify,
  analyticsInit,
  analyticsPage,
  setAnalyticsSessionId,
} from '../../services/analytics';
import { useGetStyxConfigQuery } from '../../store/api/styx';

const AnalyticsInitializer: React.FC = () => {
  const { user } = useAuth();
  const { data: styxConfig } = useGetStyxConfigQuery(undefined, {
    skip: !user,
    refetchOnMountOrArgChange: true,
  });

  const initializedTokenRef = useRef<string | null>(null);
  const appOpenedRef = useRef(false);
  const identifiedUserIdRef = useRef<number | null>(null);
  const identifiedSessionIdRef = useRef<string | null>(null);

  useEffect(() => {
    const configToken = styxConfig?.data?.token ?? null;
    const configHost = styxConfig?.data?.host ?? null;

    if (
      configToken &&
      configHost &&
      initializedTokenRef.current !== configToken
    ) {
      analyticsInit({
        serverHost: configHost,
        writeKey: atob(configToken),
      });
      initializedTokenRef.current = configToken;

      if (!appOpenedRef.current) {
        analyticsPage(AnalyticsEvent.APPLICATION_OPENED, {
          link: window.location.href,
        });
        appOpenedRef.current = true;
      }
    }

    if (!initializedTokenRef.current || !user) {
      return;
    }

    if (identifiedUserIdRef.current !== user.id) {
      analyticsIdentify(user.id);
      identifiedUserIdRef.current = user.id;
    }

    const sessionId = user.extraData.session ?? null;
    if (sessionId && identifiedSessionIdRef.current !== sessionId) {
      setAnalyticsSessionId(sessionId);
      identifiedSessionIdRef.current = sessionId;
    }
  }, [styxConfig, user]);

  return null;
};

export default AnalyticsInitializer;
